import { useState } from "react"
import { EllipsisMenu, useEllipsisMenuProps } from "./EllipsisMenu.types"

const useEllipsisMenu = (props: useEllipsisMenuProps) => {

  const { items } = props

  const [showMenu, setShowMenu] = useState<boolean>(false)

  const ellipsisMenu: EllipsisMenu = {
    items: items,
    showMenu: showMenu,
    onClick: () => setShowMenu(true),
    onHide: () => setShowMenu(false)
  }

  return { ellipsisMenu }
}

export default useEllipsisMenu